import React from 'react'

const Loading: React.FC = (props) => {
  return (
    <span>Loading...</span>
  )
}

export default Loading
